function CodStatusColumnFilter({ column: { setFilter, filterValue } }) {
  const handleOnChange = (event) => {
    setFilter(event.target.value || "");
  };

  return (
    <select
      value={filterValue || ""}
      className="form-control form-control-sm order-history-table-filters"
      onChange={handleOnChange}
    >
      <option value="">All</option>
      <option value="no">No</option>
      <option value="yes">Yes</option>
      <option value="unpaid">Unpaid</option>
      <option value="paid">Paid</option>
      <option value="partial">Partial</option>
    </select>
  );
}

export default CodStatusColumnFilter;
